import React, { useEffect } from 'react';
import { Routes, Route, Navigate, useNavigate } from 'react-router-dom';
import { useUser } from '../context/UserContext';
import StudentLayout from '../components/student/StudentLayout';
import StudentSessions from '../components/student/StudentSessions';
import AvailableSessions from '../components/student/AvailableSessions';
import UserSettings from '../components/student/UserSettings';
import Classroom from '../components/student/Classroom';
import './StudentDashboard.css';

const StudentDashboard = () => {
  const { user } = useUser();
  const navigate = useNavigate();

  useEffect(() => {
    if (!user || user.type !== 'student') {
      navigate('/');
    }
  }, [user, navigate]);

  if (!user || user.type !== 'student') {
    return null;
  }

  return (
    <StudentLayout>
      <Routes>
        <Route path="/" element={<Navigate to="/student/registered" replace />} />
        <Route path="/registered" element={<StudentSessions />} />
        <Route path="/sessions" element={<StudentSessions />} />
        <Route path="/available" element={<AvailableSessions />} />
        <Route path="/settings" element={<UserSettings />} />
        <Route path="/classroom/:sessionId" element={<Classroom />} />
      </Routes>
    </StudentLayout>
  );
};

export default StudentDashboard;

